import { RouterItemType } from "@/app/index";
import { lazy } from "react";

const LayoutPageReferral = lazy(() => import("./layout/index"));

export const routerPageReferral: RouterItemType = {
  path: "/referral",
  authorize: true,
  element: <LayoutPageReferral />,
};
